"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.read = void 0;
const sqs = __importStar(require("@aws-sdk/client-sqs"));
const event = __importStar(require("./index"));
/**
 * Reads messages by polling the SQS queue dedicated to this this application.
 * This function will send a request to SQS every `waitTimeSeconds` seconds. It will wait a maximum of `waitTimeSeconds`
 * seconds per equest, but will return as soon as any message(s) is/are available during that time.
 *
 * More than 1 message may be received from SQS. Loop through them and call the provided handler which is passed in to
 * handle the event. Once the handler resolves the promise indicating that the event was handled, the event is deleted
 * from the queue. If an event handler fails the event will be visible on the queue again after `visibilityTimeout`
 * seconds
 *
 * @param eventHandler
 * @param receiveMsgParams
 * @param errorHandler
 * @param fifo Whether to read from the first in first out (fifo) queue or not.
 */
const read = (eventHandler, receiveMsgParams, errorHandler, fifo = true) => {
    const client = new sqs.SQSClient({ region: event.config.region });
    const queueUrl = fifo
        ? event.config.messageFifoQueueUrl
        : event.config.messageQueueUrl;
    const sqsParams = {
        AttributeNames: ['CreatedTimestamp'],
        MaxNumberOfMessages: receiveMsgParams.maxNumberOfMessages,
        MessageAttributeNames: ['All'],
        QueueUrl: queueUrl,
        VisibilityTimeout: receiveMsgParams.visibilityTimeout,
        WaitTimeSeconds: receiveMsgParams.waitTimeSeconds,
    };
    return setInterval(() => {
        client
            .send(new sqs.ReceiveMessageCommand(sqsParams))
            .then((data) => {
            if (data.Messages) {
                data.Messages.forEach((message) => {
                    const msgBody = JSON.parse(message.Body);
                    if (!msgBody.MessageAttributes.Domain ||
                        !msgBody.MessageAttributes.Name)
                        return;
                    eventHandler({
                        messageId: message.MessageId,
                        domain: msgBody.MessageAttributes.Domain.Value,
                        name: msgBody.MessageAttributes.Name.Value,
                        timestamp: msgBody.Timestamp,
                        data: JSON.parse(msgBody.Message),
                    })
                        .then(() => {
                        // Event was successfully handled, so delete it from the queue.
                        client.send(new sqs.DeleteMessageCommand({
                            QueueUrl: queueUrl,
                            ReceiptHandle: message.ReceiptHandle,
                        }));
                    })
                        .catch((err) => {
                        // Event was not successfully handled, so do not delete it from the queue.
                    });
                });
            }
        })
            .catch((err) => {
            errorHandler(err);
        });
    }, receiveMsgParams.requestIntervalMs);
};
exports.read = read;
